import Color from 'color';
import styled from 'styled-components';

import {getColor, getRem, ms, msi} from '@yourcoach/shared/styles';
import {Clickable} from '@yourcoach/shared/uikit/Clickable';
import {LoadingSpinner} from '@yourcoach/shared/uikit/LoadingSpinner';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Wrapper = styled(Clickable)`
  align-self: center;
  flex-shrink: 0;
`;

export const Container = styled(View)`
  position: relative;
  overflow: hidden;
  background-color: ${getColor('global5')};
  border-radius: ${ms(20)};
  height: ${ms(40)};
  padding: 0 ${ms(15)};
  align-items: center;
  justify-content: center;
  box-shadow: 0 ${ms(4)} ${ms(20)}
    ${p => Color(getColor('global5')(p)).alpha(0.5).toString()};

  &:hover {
    background-color: ${p =>
      Color(getColor('global5')(p)).lighten(0.2).toString()};
    box-shadow: none;
  }
`;

export const TimeContainer = styled(View)`
  justify-content: center;
`;

const SText = styled(Text).attrs(p => ({weight: p.weight || 'semibold'}))`
  font-size: ${getRem(13)};
  line-height: ${getRem(18)};
  text-align: center;
  color: ${getColor('text.white')};
`;

export {SText as Text};

export const Spinner = styled(LoadingSpinner).attrs({
  size: msi(20),
  strokeInnerColor: 'text2',
  strokeOuterColor: 'text2',
})`
  margin-inline-start: ${ms(10)};
  position: absolute;
  inset-inline-start: ${ms(2)};
  bottom: 0;
`;
